import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { FirebaseContext } from '@components/Firebase';
import { navigate } from 'gatsby';

import NProgress from 'nprogress';
import Google from '@images/social/google.svg';
import Facebook from '@images/social/facebook.svg';
import Github from '@images/social/github.svg';
import * as ROUTES from '@utils/routes';
import { PresentMessage } from '@styles';

const OtherLoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--darkText);
`;

const BreakerText = styled.h2`
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: 700;
  display: inline-block;
  font-size: 1.25rem;
`;

const BtnContainer = styled.div`
  padding: 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const BtnContainerItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;

  img {
    width: 1.5rem;
  }
`;

const BtnWrapper = styled.div`
  align-items: center;
  background-color: var(--darkButton);
  border: 2px solid var(--border);
  display: block;
  display: flex;
  height: 100%;
  justify-content: center;
  margin-bottom: 0.5rem;
  min-width: 100%;
  padding: 0.5rem 1rem;
  text-align: left;
  transition: box-shadow 0.3s ease;

  :hover {
    cursor: pointer;
    box-shadow: 0 0 20px var(--shadow);
  }
`;

const SocialLogin = () => {
  const { firebase } = useContext(FirebaseContext) || {};

  return (
    <OtherLoginContainer>
      <div>
        <BreakerText>Or continue with another account</BreakerText>
        <BtnContainer>
          <BtnContainerItem>
            <BtnWrapper
              onClick={() =>
                NProgress.start() &&
                firebase
                  .doSignInWithGoogle()
                  .then((response) => {
                    if (response.additionalUserInfo.isNewUser) {
                      return firebase.socialLogin();
                    } else {
                      throw new Error('Abort promise chain');
                    }
                  })
                  .then(() => {
                    firebase.analytics.logEvent('sign_up', {
                      method: 'google',
                    });
                    NProgress.done();
                    navigate(ROUTES.APP_PROFILE);
                  })
                  .catch((err) => {
                    NProgress.done(true);
                    if (err.message === 'Abort promise chain') {
                      navigate(ROUTES.APP_PROFILE);
                    } else {
                      firebase.analytics.logEvent('exception', {
                        description: err,
                        fatal: false,
                      });
                      PresentMessage('error', err.message);
                    }
                  })
              }
            >
              <img src={Google} alt="Sign up with Google" />
            </BtnWrapper>
          </BtnContainerItem>
          <BtnContainerItem>
            <BtnWrapper
              onClick={() =>
                NProgress.start() &&
                firebase
                  .doSignInWithFacebook()
                  .then((response) => {
                    if (response.additionalUserInfo.isNewUser) {
                      return firebase.socialLogin();
                    } else {
                      throw new Error('Abort promise chain');
                    }
                  })
                  .then(() => {
                    firebase.analytics.logEvent('sign_up', {
                      method: 'google',
                    });
                    NProgress.done();
                    navigate(ROUTES.APP_PROFILE);
                  })
                  .catch((err) => {
                    NProgress.done(true);
                    if (err.message === 'Abort promise chain') {
                      navigate(ROUTES.APP_PROFILE);
                    } else {
                      firebase.analytics.logEvent('exception', {
                        description: err,
                        fatal: false,
                      });
                      PresentMessage('error', err.message);
                    }
                  })
              }
            >
              <img src={Facebook} alt="Sign up with Facebook" />
            </BtnWrapper>
          </BtnContainerItem>
          <BtnContainerItem>
            <BtnWrapper
              onClick={() =>
                NProgress.start() &&
                firebase
                  .doSignInWithGithub()
                  .then((response) => {
                    if (response.additionalUserInfo.isNewUser) {
                      return firebase.socialLogin();
                    } else {
                      throw new Error('Abort promise chain');
                    }
                  })
                  .then(() => {
                    firebase.analytics.logEvent('sign_up', {
                      method: 'google',
                    });
                    NProgress.done();
                    navigate(ROUTES.APP_PROFILE);
                  })
                  .catch((err) => {
                    NProgress.done(true);
                    if (err.message === 'Abort promise chain') {
                      navigate(ROUTES.APP_PROFILE);
                    } else {
                      firebase.analytics.logEvent('exception', {
                        description: err,
                        fatal: false,
                      });
                      PresentMessage('error', err.message);
                    }
                  })
              }
            >
              <img
                className="darkIcon"
                src={Github}
                alt="Sign up with Github"
              />
            </BtnWrapper>
          </BtnContainerItem>
        </BtnContainer>
      </div>
    </OtherLoginContainer>
  );
};

export default SocialLogin;
